import React from 'react'
import InfoIcon from '@mui/icons-material/Info'
import { TooltipProps } from '@mui/material'
import { CustomTooltip } from '../customTooltip/CustomTooltip'
import './InfoTooltip.scss'

export const InfoTooltip = ({ title,size }:
                            {title: TooltipProps['title'],
                                size?: 'inherit' | 'small' | 'medium' | 'large'
                            }) => (
    <CustomTooltip title={title}>
        <InfoIcon className="info-icon" fontSize={size}/>
    </CustomTooltip>
)
